export default __webpack_public_path__ + "53e2cb47bfc507917214a80092c2eae3.png";